import { render, staticRenderFns } from "./SolutionAdd.vue?vue&type=template&id=00d36db8&scoped=true&"
import script from "./SolutionAdd.vue?vue&type=script&lang=js&"
export * from "./SolutionAdd.vue?vue&type=script&lang=js&"
import style0 from "./SolutionAdd.vue?vue&type=style&index=0&id=00d36db8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d36db8",
  null
  
)

export default component.exports